import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'pagination'})
export class PaginationPipe implements PipeTransform {
    transform(value: any[], args): any {
        if(!value) return
        return [...value.slice( args.itemsPerPage*(args.currentPage-1) , args.itemsPerPage*(args.currentPage))]
        // return [...value]
    }
}